"use client";

import { withSearchParams } from "@trydig/ui/next";
import { Skeleton } from "@/components/ui/Skeleton";
import { useArticles } from "@/features/articles/ArticleListingPage/ArticlesProvider";
import { ARTICLES_FILTER_QUERY } from "@/features/articles/config";
import styles from "./ArticleFilterbar.module.css";

export const ArticleFilterbar = withSearchParams(({ searchParams }) => {
	const { articleFilterTags } = useArticles();

	if (articleFilterTags.length <= 2) return null;

	const currentSelectedTag = searchParams.get(ARTICLES_FILTER_QUERY);

	return (
		<div className={styles.root}>
			{articleFilterTags.map((tag, i) => (
				<button
					key={`${tag.name}-${i}`}
					className={styles.tag}
					type="button"
					data-active={
						(tag.root && !currentSelectedTag) || tag.name === currentSelectedTag
					}
					onClick={() => {
						if (tag.root) {
							return searchParams.delete(ARTICLES_FILTER_QUERY);
						}
						searchParams.set(ARTICLES_FILTER_QUERY, tag.name);
					}}
				>
					{tag.name}
				</button>
			))}
		</div>
	);
});

export const ArticleFilterbarSkeleton = ({ size = 4 }: { size?: number }) => {
	return (
		<div className={styles.root}>
			{[...Array(size)].map((_, idx) => (
				<Skeleton fitContent key={idx}>
					<button className={styles.tag} type="button">
						lorem
					</button>
				</Skeleton>
			))}
		</div>
	);
};
